import { DemoteReviewersCardShared } from '@scale/genai-compass-shared/cards/demote_reviewers';
import { makeAutoOpsCardUI } from '../constants';
import { faUserMinus } from '@fortawesome/pro-solid-svg-icons';

export const DemoteReviewersCardUI = makeAutoOpsCardUI(DemoteReviewersCardShared, {
  button: { icon: faUserMinus },
});
